const locationListsToggle = () => {
    const toggleBlocks = document.querySelectorAll('.js-location-block');
    const toggleBtn = document.querySelector('.js-location-toggle');

    if(toggleBlocks.length === 0) return

    toggleBtn.addEventListener('click', () => {
        toggleBlocks.forEach(block => block.classList.toggle('hidden'));
        toggleBtn.classList.toggle('show-more');
    })
}

export default locationListsToggle
